import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            视频分类
          </h2>
          <Link to="/category/hot" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-3 p-4 rounded-lg bg-background-100/70 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 shrink-0">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs text-foreground-500 whitespace-nowrap">{cat.count} 部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}